import React, { SetStateAction, useEffect, useState } from "react";
import * as S from "./bottomSheetSelectBox.styles";
import { SearchType } from "../../../../interface/transportation";

export interface BottomSheetSelectBoxProps {
  type: string;
  label: string;
  size?: "sm" | "md" | "lg" | "full";
  isReset: boolean;
  search: SearchType[];
  setIsReset: React.Dispatch<React.SetStateAction<boolean>>;
  setSearch: React.Dispatch<React.SetStateAction<SearchType[]>>;
}

export const BottomSheetSelectBox = ({
  type,
  label,
  size,
  isReset,
  search,
  setIsReset,
  setSearch,
}: BottomSheetSelectBoxProps) => {
  const [selected, setSelected] = useState<boolean>(false);

  useEffect(() => {
    const isSelected = search.some(
      (data) => data.data === label && data.point === type
    );
    setSelected(isSelected);

    if (selected && isReset) {
      setSelected(false);
    }
  }, [search, label, type]);

  const handleSelectBoxChange = () => {
    if (selected) {
      setSearch((prev: SearchType[]) =>
        prev.filter(
          (item: SearchType) => item.data !== label || item.point !== type
        )
      );
    } else {
      setSearch((prev: SearchType[]) => [
        { data: label, point: type },
        ...prev,
      ]);
    }

    setSelected(!selected);
    setIsReset(false);
  };

  return (
    <S.BottomSheetSelectBox
      onClick={handleSelectBoxChange}
      className={selected ? "selected" : ""}
      size={size}
    >
      <p> {label} </p>
    </S.BottomSheetSelectBox>
  );
};
